import { render } from "./System.vue?vue&type=template&id=6ae9077c&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"

import "./System.vue?vue&type=style&index=0&id=6ae9077c&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae9077c"]])

export default __exports__